import { MISSING_STAT } from '../constants'
import type { GameOutcome, GameResult, GameStat } from '../types'

const getSuffix = (game: GameStat['game']): string => {
  if (game.shootout) {
    return ' SO'
  }
  if (game.overtime) {
    return ' OT'
  }
  return ''
}

export const buildGameResult = (g: GameStat): GameResult => {
  const { home_team_score: home, visiting_team_score: visiting } = g.game
  if (home === null || visiting === null) {
    return { outcome: null, label: MISSING_STAT }
  }
  const own = g.is_home ? home : visiting
  const other = g.is_home ? visiting : home
  let outcome: GameOutcome = 'T'
  if (own > other) {
    outcome = 'W'
  } else if (own < other) {
    outcome = 'L'
  }
  return { outcome, label: `${outcome} ${own}–${other}${getSuffix(g.game)}` }
}

/** The word before an opponent's name, home or away. */
export const MATCHUP_PREFIX = 'vs'

/**
 * How a game names its opponent: always "vs <opponent>", home or away. The
 * user chose one wording over the "@" away shorthand, which read as unclear.
 */
export const formatMatchup = (g: GameStat): string =>
  `${MATCHUP_PREFIX} ${g.opponent.name_full}`
